import React from "react";
import Cart from "../components/Cart/Cart";

export default function CartPage(props) {
  return <Cart props={props} />;
}
